import React, { useState } from "react";
import { Rating, Tooltip } from "@mui/material";
import { MdRateReview } from "react-icons/md";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import TextFieldCustom from "../../../component/elements/textfieldCustom";
import { Player } from "@lottiefiles/react-lottie-player";
import ratingAndReview from "../../../assets/animation/ratingAndReview.json";

export default function RatingsReviews({
  onClose,
  mode = "Submit",
  reviewDetails = {},
  onSubmit,
}) {
  
  console.log(reviewDetails)
  const [hover, setHover] = useState(-1);
  const [rating, setRating] = useState(reviewDetails?.score ?? 0);
  const [feedback, setFeedback] = useState(reviewDetails?.content ?? "");
  const [showTooltip, setShowTooltip] = useState(false);
  const isReadOnly = reviewDetails?.score && reviewDetails?.content;

  const labels = {
    1: "Very Bad",
    2: "Bad",
    3: "Okay",
    4: "Good Service",
    5: "Excellent Service",
  };

  const handleSubmit = () => {
    if (rating > 0 && feedback.trim()) {
      onSubmit({ rating, feedback });
      setShowTooltip(false);
    } else {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 2000);
    }
  };

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <div className="bg-white rounded-xl shadow p-4 md:col-span-2">
      {/* Header */}
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-semibold text-lg">
          {!isReadOnly && "Share your laundry experience"}
        </h3>
        <button
          onClick={onClose}
          className="text-gray-600 hover:text-black"
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>

      <Player
        autoplay
        loop
        src={ratingAndReview}
        style={{ height: "180px", width: "180px" }}
      />

      {isReadOnly ? (
        <div className="space-y-4 pb-4">
          <div className="text-2xl font-semibold text-green-600 text-center">
            Thank you for your feedback!
          </div>

          {/* Stars */}
          <div className="flex justify-center">
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                className={`text-2xl ${
                  star <= reviewDetails.score
                    ? "text-yellow-400"
                    : "text-gray-300"
                }`}
              >
                ★
              </span>
            ))}
          </div>

          {/* Your feedback */}
          <div className="relative border-l-4  border-blue-400 bg-gradient-to-r from-blue-50 to-white shadow rounded-md p-3 pl-4">
            <div className="absolute -left-3 -top-3 bg-blue-400 text-white text-[10px] px-2 py-[2px] mb-2 rounded-full">
              Your Feedback
            </div>
            <div className="text-gray-800 text-sm">{reviewDetails.content}</div>
            {reviewDetails.createdAt && (
              <div className="text-xs text-gray-500 mt-1 text-right">
                {formatDate(reviewDetails.createdAt)}
              </div>
            )}
          </div>

          {reviewDetails.messages?.length > 0 && (
            <div className="space-y-2 mt-3">
              {reviewDetails.messages.map((msg, idx) => (
                <div
                  key={idx}
                  className="relative border-l-4 border-green-400 bg-gradient-to-r from-green-50 to-white shadow rounded-md p-3 pl-4"
                >
                  <div className="absolute -left-3 -top-3 bg-green-400 text-white text-[10px] px-2 py-[2px] rounded-full">
                    Reply from Store
                  </div>
                  <div className="text-gray-800 text-sm">{msg.content}</div>
                  <div className="text-xs text-gray-500 mt-1 text-right">
                    {formatDate(msg.sentAt)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <>
          {/* Star Rating */}
          <div className="flex items-center gap-3 mt-2">
            <Rating
              name="hover-feedback"
              value={rating}
              precision={1}
              onChange={(e, newValue) => setRating(newValue)}
              onChangeActive={(e, newHover) => setHover(newHover)}
              size="large"
            />
            {rating !== null && (
              <div className="text-sm font-medium text-green-600">
                {labels[hover !== -1 ? hover : rating]}
              </div>
            )}
          </div>

          {/* Feedback input */}
          <div className="mt-3">
            <label className="block text-sm font-medium mb-1">
              Tell us about the service
            </label>
            <TextFieldCustom
              placeholder="Was the pickup on time? How was the quality of cleaning?"
              heightClass="custom-textarea-height"
              fullWidth
              multiline
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            />
          </div>

          {/* Submit */}
          <div className="flex justify-end mt-3">
            <Tooltip
              open={showTooltip}
              title="Please add rating and feedback"
              placement="top"
              arrow
            >
              <div>
                <CustomButton
                  onClick={handleSubmit}
                  customeClass="customer-dark-button w-[160px] h-[40px]"
                >
                  <MdRateReview className="text-lg mr-2" />
                  {mode === "Submit" ? "Submit Review" : "Update Review"}
                </CustomButton>
              </div>
            </Tooltip>
          </div>
        </>
      )}
    </div>
  );
}
